import { AbstractViewProperties } from "../../view/properties/AbstractViewProperties";
/**
 * MouseBlockerProperties.ts
 */
export class MouseBlockerProperties extends AbstractViewProperties {
    constructor(colour = 0x000000, alpha = 0, clickToDismiss = false) {
        super();
        this.colour = colour;
        this.alpha = alpha;
        this.clickToDismiss = clickToDismiss;
    }
}
//# sourceMappingURL=MouseBlockerProperties.js.map